export const STORE_USER_DATA = "USER_STORE_USER_DATA";

export const storeUserData = (token, client) => ({
  type: STORE_USER_DATA,
  token,
  client,
});
